import React from 'react';
import { Button } from 'antd';
import { FixedSizeGrid as Grid } from 'react-window';
import AutoSizer from 'react-virtualized-auto-sizer';
import { formatTicketNumber } from '../../../../util/utils';


const getColumnCount = (width) => {
    if (width < 576) return 4;
    if (width < 768) return 5;
    if (width < 992) return 7;
    if (width < 1200) return 8;
    if (width < 1600) return 12;
    return 14;
};


const Cell = React.memo(({ columnIndex, rowIndex, style, data }) => {
    const { tickets, columnCount, selectedTickets, addTicket, ticketAmount } = data;

    const ticketIndex = rowIndex * columnCount + columnIndex;
    const item = tickets[ticketIndex];

    if (!item) return null;

    const isSelected = selectedTickets.some(t => t.ticketNumber === item.ticketNumber);

    return (
        <div style={{
            ...style,
            padding: '4px',
            boxSizing: 'border-box'
        }}>
            <Button
                size="small"
                className={`w-100 little-ticket-button ${isSelected ? "selected" : ""}`}
                onClick={() => addTicket(item)}
                style={{
                    // width: '100%',
                    // height: '100%',
                    fontSize: '14px'
                }}
            >
                {formatTicketNumber(item.ticketNumber, ticketAmount)}
            </Button>
        </div>
    );
});


const VirtualizedTickets = ({ tickets, selectedTickets, addTicket, data }) => {
    if (!tickets || tickets.length === 0) {
        return <div style={{ textAlign: 'center', padding: '20px' }}>No hay boletos para mostrar</div>;
    }

    return (
        <div style={{ height: '100%', width: '100%' }}>
            <AutoSizer>
                {({ height, width }) => {
                    // Validar que AutoSizer detecte dimensiones
                    if (!height || !width) return null;

                    const columnCount = getColumnCount(width);
                    const rowCount = Math.ceil(tickets.length / columnCount);
                    // Usamos Math.floor para evitar decimales en el ancho de celda
                    const columnWidth = Math.floor(width / columnCount);

                    return (
                        <Grid
                            className="Grid"
                            columnCount={columnCount}
                            columnWidth={columnWidth}
                            height={height}
                            rowCount={rowCount}
                            rowHeight={30}
                            width={width}
                            itemData={{
                                tickets,
                                columnCount,
                                selectedTickets,
                                addTicket,
                                ticketAmount: data?.ticketAmount
                            }}
                        >
                            {Cell}
                        </Grid>
                    );
                }}
            </AutoSizer>
        </div>
    );
};

export default VirtualizedTickets;